import Joi from 'joi'

const envVarsSchema = Joi.object()
  .keys({
    VITE_API_URL                  : Joi.string().required().description('API url'),
    VITE_GCP_PUBLIC_BUCKET_URL    : Joi.string().required().description('URL of public bucket (images, pdfs, etc.)'),
    VITE_TENANT                   : Joi.string().default('maquinariasflorio').description('Tenant identifier for branding'),
    VITE_APP_NAME                 : Joi.string().default('MF ERP').description('Application name shown in the title and the PWA manifest'),
    VITE_FF_ENABLE_TENANTS_MODULE : Joi.string().valid('true', 'false').default('false').description('Feature flag to enable the tenants module'),
    VITE_SENTRY_DSN               : Joi.string().allow('').default('').description('Sentry DSN. Empty disables error reporting'),
  })
  .unknown()

const { value: envVars, error } = envVarsSchema.prefs({ errors: { label: 'key' } }).validate(import.meta.env)

if (error) {
  throw new Error(`Config validation error: ${error.message}`)
}

const config = {
  apiUrl                : envVars.VITE_API_URL,
  publicBucketUrl       : envVars.VITE_GCP_PUBLIC_BUCKET_URL,
  tenant                : envVars.VITE_TENANT,
  appName               : envVars.VITE_APP_NAME,
  ffEnableTenantsModule : envVars.VITE_FF_ENABLE_TENANTS_MODULE === 'true',
  sentryDsn             : envVars.VITE_SENTRY_DSN,
}

export default config
